import React, { useState } from 'react';
import { SalvButton, SalvModal, SalvTextField } from '@salvapp/ui-components';

interface Props {
  onClose: () => void;
  onSubmit: (note: string | undefined) => Promise<void>;
  initialNote?: string;
}

export const SaveAsDraftModal = ({ onClose, onSubmit, initialNote }: Props) => {
  const [note, setNote] = useState(initialNote ?? '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setIsSubmitting(true);
    onSubmit(note.trim() ? note.trim() : undefined).finally(() => setIsSubmitting(false));
  };

  return (
    <SalvModal show={true} onHide={onClose}>
      <SalvModal.Header closeButton>
        <div className='title-s'>Save as draft</div>
      </SalvModal.Header>
      <SalvModal.Body>
        <div className='m-b-16'>
          <SalvTextField label='Note (optional)' value={note} onChange={(value: string) => setNote(value)} />
        </div>
      </SalvModal.Body>
      <SalvModal.Footer>
        <SalvButton label='Cancel' variant='muted' onClick={onClose} />
        <SalvButton label='Save draft' variant='primary' onClick={handleSubmit} disabled={isSubmitting} />
      </SalvModal.Footer>
    </SalvModal>
  );
};
